import Vue from 'vue';
import { SET_FETCH_START, SET_FETCH_DONE, SET_FETCH_ERRORED } from './types';
const mutations = {
    [SET_FETCH_START](state, { key, time }) {
        const obj = {
            data: state[key] ? state[key].data : null,
            startTime: time,
            status: 'fetching',
            error: null,
            userError: null,
            doneTime: null,
        };
        Vue.set(state, key, obj);
    },
    [SET_FETCH_DONE](state, { key, result }) {
        const obj = {
            ...state[key],
            data: Object.freeze(result),
            status: 'done',
            error: null,
            userError: null,
            doneTime: Date.now(),
        };
        state[key] = obj;
    },
    [SET_FETCH_ERRORED](state, { key, error, userError }) {
        const obj = {
            ...state[key],
            status: 'done',
            error: error,
            userError: userError,
            doneTime: Date.now(),
        };
        state[key] = obj;
    }
};
export default mutations;
